var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"edit_form"},[_c('edu-form',{attrs:{"title":'设置' + _vm.checkItem.name + '项目指标'},on:{"ok":function($event){return _vm.createData()},"cancel":_vm.handelCancel}},[_c('a-transfer',{attrs:{"list-style":{
			   width: '45%',
			   height: '300px',
			 },"data-source":_vm.dataSource,"target-keys":_vm.targetKeys,"render":function (item) { return item.title; }},on:{"change":_vm.handleChange}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }